module.exports = __webpack_public_path__ + "static/media/warning-pin.1c5f4829.svg";